import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import CreateRepository from '../Repositories/CreateRepository'


class CreateBloc {

    createChannel = new Subject();
    fetchcheckMonthChannel = new Subject();
    repository = new CreateRepository()

    constructor() {
        this.createChannel.next({status: apiResponse.INITIAL})
    }

    fetchCreate = async (query) => {
        try {
            this.createChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchCreate(query).then((result) => {
                this.createChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.createChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            
        }
    }

    fetchcheckMonth = async (query) => {
            this.fetchcheckMonthChannel.next({status: apiResponse.LOADING})
            try {
                 await this.repository.fetchcheckMonth(query).then((result) => {
                    this.fetchcheckMonthChannel.next({status: apiResponse.COMPLETED, data: result})
                }).catch((error) => {
                    this.fetchcheckMonthChannel.next({status: apiResponse.ERROR, data: error})
                })           
            } catch (error) {
                console.log('rxjs', 'Subject Unsubscribed')
            }
    }
}

export default CreateBloc